import React from 'react';

class NotFound extends React.Component {
  render() {
    return (
      <div data-testid="page-not-found" />
    );
  }
}

export default NotFound;
